import React from 'react';
import PropTypes from 'prop-types';

import { autoImportHeader, autoImportUncheckText } from '../integrationHelpers';
import IntegrationCustomerVendorSync from '../IntegrationCustomerVendorSync';

import { toTitleCase } from '../../../helpers/helpers';

const autoImportContent = (type) => {
  const contactText = type === 'customer' ? 'Customers' : 'Vendors';
  return (
    <div style={{ width: 500 }}>
      {autoImportHeader('Sage Intacct', contactText)}
      <br />
      <br />
      1. Make sure the
      {' '}
      {contactText}
      {' '}
      have a name set.
      <br />
      <br />
      2.
      {' '}
      {contactText}
      {' '}
      with names that conflict with existing Ontraccr
      {' '}
      {contactText}
      {' '}
      will not be imported.
      <br />
      <br />
      {autoImportUncheckText('Sage Intacct')}
    </div>
  );
};

const importHelpText = (type) => {
  const contactText = type === 'customer' ? 'Customers' : 'Vendors';

  return (
    <div style={{ width: 500 }}>
      Select from this dropdown to either
      {' '}
      <b>Import</b>
      {' '}
      new
      {' '}
      {contactText}
      {' '}
      from Sage Intacct or
      {' '}
      <b>Link</b>
      {' '}
      Sage Intacct
      {' '}
      {contactText}
      {' '}
      to existing Ontraccr
      {' '}
      {contactText}
      <br />
      <br />
      <b>Import:</b>
      {' '}
      {contactText}
      {' '}
      must have a name to be imported into Ontraccr.
      <br />
      <b>Link:</b>
      {' '}
      Select an existing Ontraccr
      {' '}
      {toTitleCase(type)}
      {' '}
      to link with the Sage Intacct
      {' '}
      {toTitleCase(type)}
      .
    </div>
  );
};

function SageIntacctContactSync({
  type,
  sageIntacctContacts,
  onContactsChanged,
  importContacts,
  divisionFilter,
}) {
  return (
    <IntegrationCustomerVendorSync
      integrationValues={sageIntacctContacts}
      title="Sage Intacct"
      integrationKey="sageId"
      onValuesChanged={onContactsChanged}
      autoImportContent={autoImportContent(type)}
      importHelpText={importHelpText(type)}
      importValues={importContacts}
      divisionFilter={divisionFilter}
      isVendor={type === 'vendor'}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
SageIntacctContactSync.propTypes = {
  type: PropTypes.string.isRequired,
  sageIntacctContacts: PropTypes.array,
  onContactsChanged: PropTypes.func.isRequired,
  importContacts: PropTypes.array,
  divisionFilter: PropTypes.instanceOf(Set),
};

SageIntacctContactSync.defaultProps = {
  sageIntacctContacts: [],
  importContacts: [],
  divisionFilter: null,
};

export default SageIntacctContactSync;

